import ClosureReasonsAPI from '../../api/saas/closureReasons';

const state = {
  records: [],
  hasFetched: false,
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getClosureReasons($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  async get({ commit, state: $state }) {
    if ($state.hasFetched || $state.uiFlags.isFetching) return;
    commit('SET_CLOSURE_REASONS_UI_FLAG', { isFetching: true });
    try {
      const response = await ClosureReasonsAPI.get();
      commit('SET_CLOSURE_REASONS', response.data);
    } catch (error) {
      // Ignore
    } finally {
      commit('SET_CLOSURE_REASONS_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, data) {
    commit('SET_CLOSURE_REASONS_UI_FLAG', { isCreating: true });
    try {
      const response = await ClosureReasonsAPI.create({
        closure_reason: data,
      });
      commit('ADD_CLOSURE_REASON', response.data);
      return response.data;
    } finally {
      commit('SET_CLOSURE_REASONS_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, { id, ...data }) {
    commit('SET_CLOSURE_REASONS_UI_FLAG', { isUpdating: true });
    try {
      const response = await ClosureReasonsAPI.update(id, {
        closure_reason: data,
      });
      commit('UPDATE_CLOSURE_REASON', response.data);
      return response.data;
    } finally {
      commit('SET_CLOSURE_REASONS_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, id) {
    commit('SET_CLOSURE_REASONS_UI_FLAG', { isDeleting: true });
    try {
      await ClosureReasonsAPI.delete(id);
      commit('DELETE_CLOSURE_REASON', id);
    } finally {
      commit('SET_CLOSURE_REASONS_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_CLOSURE_REASONS_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_CLOSURE_REASONS($state, data) {
    $state.records = data;
    $state.hasFetched = true;
  },
  ADD_CLOSURE_REASON($state, data) {
    $state.records.push(data);
  },
  UPDATE_CLOSURE_REASON($state, data) {
    const idx = $state.records.findIndex(r => r.id === data.id);
    if (idx !== -1) {
      $state.records.splice(idx, 1, data);
    }
  },
  DELETE_CLOSURE_REASON($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
